import { render, staticRenderFns } from "./uploadVoucher.vue?vue&type=template&id=313783c4&scoped=true"
import script from "./uploadVoucher.vue?vue&type=script&lang=js"
export * from "./uploadVoucher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313783c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('313783c4')) {
      api.createRecord('313783c4', component.options)
    } else {
      api.reload('313783c4', component.options)
    }
    module.hot.accept("./uploadVoucher.vue?vue&type=template&id=313783c4&scoped=true", function () {
      api.rerender('313783c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bulkyExpress/largeOrderManagement/component/uploadVoucher.vue"
export default component.exports